<template>
	<div class="card">
		<GameNav v-if="isTablet" class="fields__item"/>
		<div class="dice">
			<div v-if="isTablet" class="dice__result">{{ result }}</div>
			<div v-if="isTablet" class="dice__result-subtitle">Возможный выигрыш</div>
			<div class="dice__col">
				<div class="dice__controls">
					<div class="dice__control">
						<div class="fields__item">
							<label class="text-field__label">Сумма</label>
							<input autocomplete="off"
								   class="text-field__input text-center"
								   v-model="bet"
								   type="number"
								   @keyup="validateBet">
						</div>
						<div class="dice__control-btns">
							<button class="dice__control-btn" @click="typeBet('x2')" type="button">
                            	Удвоить
							</button>
							<button class="dice__control-btn" @click="typeBet('/2')" type="button">
								Половина
							</button>
							<button class="dice__control-btn" @click="typeBet('max')" type="button">
								Макс
							</button>
							<button class="dice__control-btn" @click="typeBet('min')" type="button">
								Мин
							</button>
						</div>
					</div>
					<div class="dice__control">
						<div class="fields__item">
							<label class="text-field__label">Процент</label>
							<input autocomplete="off"
								   class="text-field__input text-center"
								   v-model="chance"
								   type="number"
								   @keyup="validateChance">
						</div>
						<div class="dice__control-btns">
							<button class="dice__control-btn" @click="typeChance('x2')" type="button">
								Удвоить
							</button>
							<button class="dice__control-btn" @click="typeChance('/2')" type="button">
								Половина
							</button>
							<button class="dice__control-btn" @click="typeChance('max')" type="button">
								Макс
							</button>
							<button class="dice__control-btn" @click="typeChance('min')" type="button">
								Мин
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="dice__col">
				<div v-if="!isTablet" class="dice__result">{{ result }}</div>
				<div v-if="!isTablet" class="dice__result-subtitle">Возможный выигрыш</div>
				<div class="dice__controls fields__item">
					<div class="dice__control">
						<div class="dice__control-title">0 - {{ min }}</div>
						<button @click="betDiceSocket('min')" :disabled="disableBtn" class="btn btn--light btn--block">
							Меньше
						</button>
					</div>
					<div class="dice__control">
						<div class="dice__control-title">
							{{ max }} - 999999
						</div>
						<button @click="betDiceSocket('max')" :disabled="disableBtn" class="btn btn--light btn--block">Больше</button>
					</div>
				</div>

				<Loader v-if="disableBtn" class="fields__item" :loading="disableBtn"/>

				<div v-show="notification.success" class="dice__success btn btn--success btn--block fields__item">
					{{ notification.success }}
				</div>

				<div v-show="notification.error" class="dice__danger btn btn--block">
					{{ notification.error }}
				</div>
			</div>
		</div>
		<AllHistory />
	</div>
</template>

<script>
    import AllHistory from "../../components/History/AllHistory.vue";
	import { mapState } from 'pinia';
	import { useUserStore } from '../../stores/User';
	import Loader from "../../components/blocks/Loader.vue";
	import BreakpointsMixin from "../../mixins/breakpoints-mixin.vue";
	import GameNav from "../../components/blocks/GameNav.vue";

    export default {
        components: {
			GameNav,
			Loader,
            AllHistory
        },

		mixins: [
			BreakpointsMixin
		],

        data() {
            return {
                bet: 1,
                chance: 80,
                result: 1.25,
                maxChance: 95,
                minChance: 1,
                min: 799999,
                max: 200000,
                disableBtn: false,
                notification: {},
                myGames: [],
            }
        },
        mounted() {
            this.initGame();
            // this.getHash();
        },

		computed: {
			...mapState(useUserStore, ['user']),
		},
        
        methods: {
            initGame() {
                if(this.user) {
					this.maxChance = +this.user.game_rules.dice_max_chance;
                }

                this.$root.isLoading = false;
            },
            validateBet() {
                if(typeof this.bet === 'string') {
                    this.bet = this.bet.replace(',', '.');
                }
                
                if (this.bet > 1000000) {
                    this.bet = 1000000;
                }

				if (this.user && this.user.balance < this.bet) {
					this.bet = this.user.balance;
				}

                if (this.bet.length && !isNaN(this.bet) && this.bet < 1) {
                    this.bet = 1;
                }

                this.resultSize();
            },
            validateChance() {
                if(typeof this.chance === 'string') {
                    this.chance = this.chance.replace(',', '.');
                }

                if (this.chance > this.maxChance) {
                    this.chance = this.maxChance;
                }

                if (this.chance.length && !isNaN(this.chance) && this.chance < this.minChance) {
                    this.chance = this.minChance;
                }
  
                this.resultSize();
            },
            resultSize() {
                if (this.bet > 1000000) {
                    this.bet = 1000000;
                }

				if (this.user && this.user.balance < this.bet) {
					this.bet = this.user.balance;
				}

                this.result = (parseFloat(((100 / parseFloat(this.chance)) * parseFloat(this.bet)) * 100))/100;

                if(isNaN(this.result)) {
                    this.result = '';
                } else {
                    this.result = this.result.toFixed(2);
                }
  
                this.min = Math.floor((this.chance / 100) * 999999);
                this.max = 999999 - Math.floor((this.chance / 100) * 999999);
            },
            typeBet(type) {
                switch (type) {
                    case "max":
                        if (this.user !== null) {
                            this.bet = this.user.balance;
                        } else {
                            this.bet = 0;
                        }
                        break;
                    case "min":
                        this.bet = 1;
                        break;
                    case "x2":
						this.bet = this?.user?.balance && this.bet * 2 > +this.user.balance ? this.user.balance : (this.bet * 2).toFixed(2);
                        break;
                    case "/2":
                        this.bet = (this.bet / 2).toFixed(2);
                        break;
                }

                this.validateBet();
                this.resultSize();
            },
            typeChance(type) {
                let newChance;

                switch (type) {
                    case "max":
                        this.chance = this.maxChance;
                        break;
                    case "min":
                        this.chance = this.minChance;
                        break;
                    case "x2":
                        newChance = (this.chance * 2).toFixed(2);
                        this.chance = newChance > this.maxChance ? this.maxChance : newChance;
                        break;
                    case "/2":
                        newChance = (this.chance / 2).toFixed(2);
                        this.chance = newChance < this.minChance ? this.minChance : newChance;
                        break;
                }

                this.validateChance();
                this.resultSize();
            },
            betDiceSocket(type) {
                switch (type) {
                    case "max":
                        this.betType = 1;
                    break;
                    case "min":
                        this.betType = 0;
                    break;
                }

                this.notification = {};
                this.disableBtn = true;

                if (!this.$cookie.get('token')) {
                    this.notification.error = 'Авторизуйтесь';

                    this.disableBtn = false;

                    return;
                }

                if (this.user && this.bet > this.user.balance) {
                    this.notification.error = 'Средств на вашем балансе недостаточно';

                    this.disableBtn = false;

                    return;
                }

                if (isNaN(this.bet)) {
                    this.notification.error = 'Введите число';

                    this.disableBtn = false;

                    return;
                }

                if (this.bet.length === 0) {
                    this.notification.error = 'Введите сумму ставки';

                    this.disableBtn = false;

                    return;
                }

                if (this.chance.length === 0) {
                    this.notification.error = 'Выберите шанс';

                    this.disableBtn = false;

                    return;
                }

                if (isNaN(this.chance)) {
                    this.notification.error = 'Шанс должен быть числом от ' + this.minChance + ' до ' + this.maxChance;

                    this.chance = this.maxChance;

                    this.disableBtn = false;

                    return;
                }

                if (this.chance > this.maxChance) {
                    this.notification.error = 'Максимальный шанс ' + this.maxChance;

                    this.chance = this.maxChance;

                    this.disableBtn = false;

                    return;
                }

                if (this.chance < this.minChance) {
                    this.notification.error = 'Минимальный шанс ' + this.minChance;

                    this.chance = this.minChance;

                    this.disableBtn = false;

                    return;
                }

				this.$root.axios.post('/api/game/dice/play', {
                    side: this.betType,
                    bet: this.bet,
                    chance: this.chance
                }).then(res => {
                    const data = res.data;

                    this.user.balance = data.balance;

                    if (data.winner) {
                        this.notification.success = data.message;
                    } else {
                        this.notification.error = data.message;
                    }

                    if(data.wager <= 0) {
                        this.initGame();
                    }

                    this.disableBtn = false;
                }).catch(error => {
                    this.notification.error = this.$root.graphql.axiosGetError(error);
                    this.disableBtn = false;
                });
            },
            addMyHistory(bet) {
                if (this.myGames.length >= 20) {
                    this.myGames.pop();
                }

                this.myGames.unshift({
                    game: 'dice',
                    id: bet.id,
                    username: this.user.username,
                    bet: bet.bet,
                    chance: bet.chance,
                    win: bet.win
                });
            }
        }
    }
</script>